import moment from 'moment/moment';
import {
  MY_FILTER,
  // 单数据源筛选器
  SINGLE_SOURCE_SELECT as SINGLE_SOURCE_SELECT_FILTER,
  SINGLE_SOURCE_SELECT_EXTEND_TYPE,
  // 级联国家筛选器
  REGION as REGION_SELECT_FILTER,
  REGION_EXTEND_TYPE,
  // 品类筛选器
  GENRETOR as GENRE_SELECT_FILTER,
  // 日期筛选器
  RANGE_TIME as RANGE_TIME_SELECT_FILTER,
  // Product Model筛选器
  SENSOR_TOWER_TAG_PRODUCT_MODEL,
} from '@/pages/intelligence/components/Filter/FilterBase/_config';
import { MOBILE_SOURCES } from '@/pages/intelligence/_config/storeRank/config';

/**
 * 判断每一个date是否有效（配置的props名字disabledDate 语意刚好是相反的）
 * 这里是禁用当天以后的日期
 * @param date Moment日期对象
 * @return 当前date是否有效
 */
const isValidDate = (date: moment.Moment): boolean => {
  if (!date?.isValid()) return true;
  return date?.isSameOrBefore(moment(), 'day');
};

// 静态筛选器配置，即所有配置相关的都是常量，不需要通过组件props、组件其他state、组件其他变量来决定 可以单独写在一个js文件中
export const STATIC_FILTER_CONFIGS = {
  MY_FILTER: {
    savePopupVisble: 0,
    key: MY_FILTER,
    style: { width: 140 },
    value: '',
  },
  SINGLE_SOURCE: {
    savePopupVisble: 1,
    key: SINGLE_SOURCE_SELECT_FILTER,
    type: SINGLE_SOURCE_SELECT_FILTER,
    extendFilterType: SINGLE_SOURCE_SELECT_EXTEND_TYPE.common,
    visible: 1,
    disabled: false,
    entityType: 'mobile',
    sources: MOBILE_SOURCES,
    isNotSaveByDefault: true, // 保存弹窗默认不勾选
  },
  REGION: {
    savePopupVisble: 1,
    key: REGION_SELECT_FILTER,
    type: REGION_SELECT_FILTER,
    extendFilterType: REGION_EXTEND_TYPE.common,
    visible: 1,
    disabled: false,
    // "popularList": [
    //   "br",
    //   "mx",
    //   "ru",
    //   "tr",
    //   "us"
    // ],
    options: [],
    className: 'hot-tags-region-select',
    entityType: 'mobile'
  },
  RANGE_TIME: {
    savePopupVisble: 1,
    key: RANGE_TIME_SELECT_FILTER,
    type: RANGE_TIME_SELECT_FILTER,
    visible: 1,
    disabled: false,
    disabledDate: isValidDate,
    calendarType: 'date',
    autoRange: {
      timeType: 'date',
      length: 0,
    },
    showSelectType: false,
    showShortcut: false,
  },
  SENSOR_TOWER_TAG_PRODUCT_MODEL: {
    savePopupVisble: 1,
    key: SENSOR_TOWER_TAG_PRODUCT_MODEL,
    title: 'dbi_detail_product_model',
    default: {
      value: [],
    },
  },
};

// 各个筛选器组件UI渲染需要的value
export const DEFAULT_FORM_VALUE = {
  [MY_FILTER]: {
    value: '',
  },
  [SINGLE_SOURCE_SELECT_FILTER]: {
    value: MOBILE_SOURCES[0],
  },
  [REGION_SELECT_FILTER]: {
    type: 'market',
    regions: [],
    markets: ['global'],
  },
  [GENRE_SELECT_FILTER]: {
    source: 'sensortower',
    mainGenres: [],
    subGenres: [],
    level3Genres: [],
    level4Genres: [],
  },
  [SENSOR_TOWER_TAG_PRODUCT_MODEL]: {
    value: [],
  },
  [RANGE_TIME_SELECT_FILTER]: {
    type: 'date',
    value: [moment(), moment()],
  },
};
